import { queryClient } from 'App';

import { appointmentKeys } from 'lib/queries/appointmentKeys';
import { invalidateAllAppointments } from 'lib/queries/appointmentInvalidation';

export default async (data) => {
  const { patient } = data;

  queryClient.setQueryData(['patient', patient?.id], (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      patient: { ...(oldData?.patient || {}), ...patient }
    };
  });

  // Patch the patient field in every cached appointment detail for this patient.
  const allSingleAppointmentQueries = queryClient
    .getQueryCache()
    .findAll(appointmentKeys.detailsV2());
  for (const query of allSingleAppointmentQueries) {
    queryClient.setQueryData(query.queryKey, (oldData) => {
      if (oldData && oldData?.appointment?.patient?.id === patient?.id) {
        return {
          ...oldData,
          appointment: {
            ...oldData?.appointment,
            patient: { ...oldData?.appointment?.patient, ...patient }
          }
        };
      }
      return oldData;
    });
  }

  // Broad refresh of every appointment query — behavior preserved from the
  // pre-factory implementation.
  invalidateAllAppointments(queryClient);
};
